<template>
  <div class="header-menu">
    <SiteHeaderUser v-if="account?.email" />
    <button
        v-else
        class="text-body-1 fw-medium color-blue sign-in-button"
        @click="goToSignIn"
    >
      {{$t('Sign in')}}
    </button>
  </div>
</template>

<script lang="ts" setup>
import SiteHeaderUser from "~/components/SiteHeader/SiteHeaderUser.vue"
import { useRouter, useRoute } from "vue-router";
import { useAccountStore } from "~/store/account";
const accountStore = useAccountStore();
const account = computed(() => accountStore.account);
const router = useRouter();
const route = useRoute();
const localePath = useLocalePath()
const goToSignIn = () => {
  localStorage.setItem('backLink', route.fullPath);
  router.push(localePath("/sign-in"));
}
</script>
<style lang="scss" scoped>
.header-menu {
  padding-left: 20px;
  border-left: 1px solid var(--grey-border);

  .sign-in-button {
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
